/**
 * Gates in-app debug UI (home Debug menu, duel Win/Lose / set-question HUD, `[cwf-duel]` logs).
 * Set `NEXT_PUBLIC_CWF_DEBUG_CONTROLS=true` in `apps/web/.env.local` (or `1`, `yes`, `on`).
 * Omit or set `false` / `0` to keep controls hidden in all environments.
 */
export function isCwfDebugControlsEnabled(): boolean {
  const raw = import.meta.env.NEXT_PUBLIC_CWF_DEBUG_CONTROLS?.trim().toLowerCase();
  if (!raw) return false;
  if (raw === "0" || raw === "false" || raw === "no" || raw === "off") {
    return false;
  }
  return raw === "1" || raw === "true" || raw === "yes" || raw === "on";
}
